import styled from "styled-components";

export const CreateClientDocumentsWrapper = styled.div`
  .cell-activity-type {
    min-width: 200px;
  }
  .cell-modality {
    min-width: 160px;
  }
  .cell-topics {
    min-width: 260px;
  }
  .cell-activity-class {
    min-width: 200px;
  }
  .cell-activity-status {
    min-width: 200px;
  }
  .cell-program-framework {
    min-width: 200px;
  }
  .cell-units {
    min-width: 150px;
  }
  .cell-measurement {
    min-width: 200px;
  }
  .cell-candidate-status {
    min-width: 200px;
  }
  .cell-actions {
    min-width: 140px;
  }
  .cell-actions-container {
    padding: 0 8px;
    display: flex;
    justify-content: flex-end;
    justify-content: space-around;
  }

  .form-header-right > .MuiBox-root {
    margin-right: 28px;
    display: flex;
    justify-content: flex-end;
  }
  .delete {
    margin-left: 8px;
  }
  .semi-header {
    display: flex;
    padding: 16px 28px;
    justify-content: flex-end;
    gap: 32px;
  }
`;
